import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'

const title = 'Consumers'
const headers = {
  icon: 'feather icon-users',
  title: title,
  description: 'track and manage all consumers information',
}

function CustomerPage() {
  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'Consumer ID',
            field: 'code',
          },
          {
            label: 'consumer name',
            field: 'surname',
          },
          { label: 'Email', field: 'email' },

          {
            label: 'HDP',
            field: 'balance',
            renderStyle: (data) => {
              return data.balance.toFixed(3)
            },
          },
          {
            label: 'Water (L)',
            field: 'water',
            renderStyle: (data) => {
              return data.water.toFixed(3)
            },
          },
          {
            label: 'Wallet',
            field: 'wallet',
            renderStyle: (data) => {
              return data?.wallet?.toFixed(3)
            },
          },
          {
            label: 'Consumption',
            field: 'consumption',
            renderStyle: (data) => {
              return data.consumption.toFixed(3)
            },
          },
          {
            label: 'client',
            field: 'client',
            render: ['name'],
          },
        ]}
        resource={resources.consumer}
        title={title}
        link="/clients/consumers"
      />
    </MainPage>
  )
}

export default CustomerPage
